import Marionette from 'backbone.marionette'
import template from 'text-loader!templates/newsroom/readerPlaceholder.html'

var ReaderPlaceholderView = Marionette.ItemView.extend({
  template: template
});

export default ReaderPlaceholderView;

